<div class="kr-smart-form-modal-view" :inert="!active" :class="dynamicClasses"><slot></slot></div>